import fetch from '../../fetch';
import environment from '../../../environment';
import { notifyError } from '../../../shared';
import { fetchBlob } from '../../fetchBlob';

const baseUrl = `${environment.get('API_HOST')}/MapaDinamico`;
export class Shapes {
    static DownloadVehicleFleetArea = (idLocaleFiltered, bbox) =>
        fetchBlob({
            undefined,
            url: `${baseUrl}/exportvehiclefleetarea?idLocaleFiltered=${idLocaleFiltered}&bbox=${bbox}`
        }).catch(notifyError);
}

export default Shapes;



// WEBPACK FOOTER //
// ./src/scripts/api/endpoints/shapes/index.js